<script setup lang="ts">
import { Categorey, Sex } from "@/enums/characterGeneratorEnums";
import { SelectedItems, SheetDefinition } from "@/types/sheet-definiation";
import { deepClone } from "vant/es/utils/deep-clone";
import { computed } from "vue";

const props = defineProps<{
  selectedItems: SelectedItems;
  selectedSex: Sex;
}>();

const emit = defineEmits<{
  (e: "update:selectedItems", items: SelectedItems): void;
}>();

const defList = computed(() => {
  return Object.values(props.selectedItems).flatMap((item) =>
    Object.values(item)
  );
});

const deselectedItem = (item: SheetDefinition) => {
  const newSelectedItems = deepClone(props.selectedItems);
  for (const category in newSelectedItems) {
    const categoryItems = newSelectedItems[category as Categorey];
    for (const type in categoryItems) {
      const def = categoryItems[type];
      if (def.name === item.name && def.type_name === item.type_name) {
        delete newSelectedItems[category as Categorey][type];
        break;
      }
    }
  }
  emit("update:selectedItems", newSelectedItems);
};
</script>
<template>
  <div class="flex flex-col gap-2">
    <div class="grid grid-cols-3 gap-2 overflow-y-auto p-2 content-start">
      <DefiniationItem
        v-for="item in defList"
        :key="`${item.name}-${item.selectedVariant}-${props.selectedSex}`"
        :definition="item"
        :is-selected="false"
        :selected-sex="props.selectedSex"
        :variant-idx="item.selectedVariant"
        @click="deselectedItem(item)"
      />
    </div>
  </div>
</template>
